import {
  provideTenantType,
  createRefreshBuddyPopover,
} from "@athena/refresh-buddy";
import { CookieUtil } from "@/helpers/cookie-util";
import { AppToken } from "../request";

let RefreshBuddy$ = null;

const envServiceAPI = {
  checkEnvToReload: () => {
    const routerKey = CookieUtil.get("routerKey");
    const config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : null;
    const remoteAppToken = JSON.parse(localStorage.getItem("config"))?.appToken;
    const token = localStorage.getItem("token");
    const param = {
      url: config.aimUrl,
      appId: "sc-console-web", // 如平台的 appId 是 mui
      headers: {
        token,
        routerKey,
        "digi-middleware-auth-app": remoteAppToken ?? AppToken,
        "digi-middleware-auth-user": token,
      },
    };
    provideTenantType(param).then((type) => {
      if (type === "PRE") {
        window.location.reload();
      }
    });
  },
  destroyEnvListener: () => {
    RefreshBuddy$ && RefreshBuddy$.destroy?.();
  },
  initEnvListener: () => {
    const config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : null;
    const routerKey = CookieUtil.get("routerKey");
    if (!routerKey) return;
    const {
      mqttUrl,
      mqttPort,
      mqttPath,
      serverName,
      mqttUserName = "",
      mqttPassword = "",
    } = config;
    const remoteAppToken = JSON.parse(localStorage.getItem("config"))?.appToken;
    const token = localStorage.getItem("token");
    RefreshBuddy$ && RefreshBuddy$.destroy?.();
    RefreshBuddy$ = createRefreshBuddyPopover({
      mqttConfig: {
        url: mqttUrl,
        port: mqttPort,
        path: mqttPath,
        userName: mqttUserName,
        password: mqttPassword,
        serverName,
        routerKey,
        appId: "sc-console-web", // 如平台的 appId 是 mui
      },
      aimConfig: {
        aimUrl: config.aimUrl,
        token,
        "digi-middleware-auth-app": remoteAppToken ?? AppToken,
        "digi-middleware-auth-user": token,
      },
      language: localStorage.getItem("language") ?? "zh_CN",
    });
  },
};
export default envServiceAPI;
